import * as XLSX from "xlsx";

enum DeviceState {
	NOT_READY_FOR_START = 0,
	INHIBIT_START = 1,
	READY_FOR_SWITCH_ON = 2,
	SWITCHED_ON = 3,
	OPERATION_RELEASED = 4,
	DISABLE_OPERATION_ACTIVE = 5,
	CLOSE_DOWN_ACTIVE = 6,
	QUICK_STOP_ACTIVE = 7,
	ERROR = 15,
	ERROR_REACTION_ACTIVE = 14,
}

export function getDeviceState(input: number): DeviceState {
	let binaryInput = input.toString(2).padStart(7, "0");
	binaryInput = binaryInput.slice(-7);

	if (/^0[01][01]0000$/.test(binaryInput)) {
		return DeviceState.NOT_READY_FOR_START;
	}

	if (/^1[01][01]0000$/.test(binaryInput)) {
		return DeviceState.INHIBIT_START;
	}

	if (/^01[01]0001$/.test(binaryInput)) {
		return DeviceState.READY_FOR_SWITCH_ON;
	}

	if (/^01[01]0011$/.test(binaryInput)) {
		return DeviceState.SWITCHED_ON;
	}

	if (/^01[01]0111$/.test(binaryInput)) {
		return DeviceState.OPERATION_RELEASED;
	}

	if (/^00[01]0111$/.test(binaryInput)) {
		return DeviceState.QUICK_STOP_ACTIVE;
	}

	if (/^0[01][01]1111$/.test(binaryInput)) {
		return DeviceState.ERROR_REACTION_ACTIVE;
	}

	if (/^0[01][01]1000$/.test(binaryInput)) {
		return DeviceState.ERROR;
	}

	return DeviceState.NOT_READY_FOR_START;
}

interface ErrorBit {
	bit: number;
	description: string;
	alarm: number;
	type: "error" | "warning"; //Falha e aviso
	parameter: number;
}

interface ErrorMessages {
	[key: string]: ErrorBit[];
}

const errorDefinitions: ErrorMessages = {
	// Parâmetro 200
	"Drivemanager.BM_d_SysError1": [
		{
			bit: 0,
			description: "Erro no microprocessador do módulo",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
		{
			bit: 1,
			description: "Erro no sistema operacional do módulo",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
		{
			bit: 2,
			description: "Erro na comunicação Proprog do módulo",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
		{
			bit: 3,
			description: "Erro em módulos funcionais ou opcionais",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
		{
			bit: 4,
			description: "Erro no módulo de alimentação",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
		{
			bit: 5,
			description: "Erro no módulo da unidade de potência",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
		{
			bit: 6,
			description: "Erro no módulo do motor",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
		{
			bit: 7,
			description: "Erro no módulo do encoder 1",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
		{
			bit: 8,
			description: "Erro no módulo do encoder 2",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
		{
			bit: 9,
			description: "Erro no gerenciador de encoder do módulo",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
		{
			bit: 10,
			description: "Erro no gerenciador de unidade do módulo",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
		{
			bit: 11,
			description: "Erro no gerenciador de dados do módulo",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
		{
			bit: 12,
			description: "Erro no controlador de posição do módulo",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
		{
			bit: 13,
			description: "Erro no controlador de velocidade especial do módulo",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
		{
			bit: 14,
			description: "Erro na programabilidade livre do módulo",
			alarm: 0,
			type: "error",
			parameter: 200,
		},
	],
	// Parâmetro 201
	"Drivemanager.BM_w_ProcessorSysError": [
		{
			bit: 1,
			description: "Erro Watchdog",
			alarm: 1,
			type: "error",
			parameter: 201,
		},
		{
			bit: 2,
			description: "Ocorrência de uma interrupção incorreta ou inesperada",
			alarm: 2,
			type: "error",
			parameter: 201,
		},
		{
			bit: 3,
			description: "Erro NMI interrupt/bus",
			alarm: 3,
			type: "error",
			parameter: 201,
		},
	],
	// Parâmetro 202
	"Drivemanager.BM_w_OperatingSysError": [
		{
			bit: 0,
			description: "Erro durante o boot",
			alarm: 16,
			type: "error",
			parameter: 202,
		},
		{
			bit: 1,
			description: "Erro de software",
			alarm: 17,
			type: "error",
			parameter: 202,
		},
		{
			bit: 2,
			description: "Configuração de intervalo de tempo",
			alarm: 18,
			type: "error",
			parameter: 202,
		},
		{
			bit: 3,
			description: "Erro de tempo - intervalo de tempo",
			alarm: 19,
			type: "error",
			parameter: 202,
		},
		{
			bit: 4,
			description: "1 = Sem memória livre",
			alarm: 20,
			type: "error",
			parameter: 202,
		},
		{
			bit: 5,
			description: "Código de erro inválido",
			alarm: 21,
			type: "error",
			parameter: 202,
		},
		{
			bit: 6,
			description: "Código de aviso inválido",
			alarm: 22,
			type: "error",
			parameter: 202,
		},
		{
			bit: 7,
			description: "Versão FPGA errada",
			alarm: 23,
			type: "error",
			parameter: 202,
		},
		{
			bit: 8,
			description:
				"Controlador de dois estados: Erro ao gravar no parâmetro de destino",
			alarm: 24,
			type: "error",
			parameter: 202,
		},
		{
			bit: 9,
			description: "Checksum de dados de flash do sistema operacional",
			alarm: 25,
			type: "error",
			parameter: 202,
		},
		{
			bit: 10,
			description: "Tipo de unidade de energia não é suportado pelo firmware",
			alarm: 26,
			type: "error",
			parameter: 202,
		},
	],
	// Parâmetro 203
	"Drivemanager.BM_w_ProprogSysError": [
		{
			bit: 0,
			description: "Protocolo Timeout",
			alarm: 32,
			type: "error",
			parameter: 203,
		},
		{
			bit: 1,
			description: "Estrutura de protocolo",
			alarm: 33,
			type: "error",
			parameter: 203,
		},
		{
			bit: 2,
			description: "Tipo de módulo errado",
			alarm: 34,
			type: "error",
			parameter: 203,
		},
		{
			bit: 3,
			description: "Dados demais no telegrama",
			alarm: 35,
			type: "error",
			parameter: 203,
		},
		{
			bit: 4,
			description: "Dados insuficientes no telegrama",
			alarm: 36,
			type: "error",
			parameter: 203,
		},
		{
			bit: 5,
			description: "Operando inválido",
			alarm: 37,
			type: "error",
			parameter: 203,
		},
		{
			bit: 6,
			description: "Tipo de memória inválido",
			alarm: 38,
			type: "error",
			parameter: 203,
		},
		{
			bit: 7,
			description: "Endereço de operando inválido",
			alarm: 39,
			type: "error",
			parameter: 203,
		},
		{
			bit: 8,
			description: "Valor menor que o valor mínimo",
			alarm: 40,
			type: "error",
			parameter: 203,
		},
		{
			bit: 9,
			description: "Valor maior que o valor máximo",
			alarm: 41,
			type: "error",
			parameter: 203,
		},
		{
			bit: 10,
			description: "Parâmetro protegido contra gravação",
			alarm: 42,
			type: "error",
			parameter: 203,
		},
		{
			bit: 11,
			description: "Parâmetros não podem ser gravados neste estado de operação",
			alarm: 43,
			type: "error",
			parameter: 203,
		},
		{
			bit: 12,
			description: "Valor de parâmetro inválido",
			alarm: 44,
			type: "error",
			parameter: 203,
		},
		{
			bit: 13,
			description:
				"Erro de comunicação com o controlador WinBASS II / ProDrive",
			alarm: 45,
			type: "error",
			parameter: 203,
		},
	],
	// Parâmetro 204
	"Drivemanager.BM_w_ExtendedModuleError": [
		{
			bit: 0,
			description: "Erro no módulo funcional A",
			alarm: 48,
			type: "error",
			parameter: 204,
		},
		{
			bit: 1,
			description: "Erro no módulo funcional B",
			alarm: 49,
			type: "error",
			parameter: 204,
		},
		{
			bit: 2,
			description: "Erro no módulo funcional C",
			alarm: 50,
			type: "error",
			parameter: 204,
		},
		{
			bit: 3,
			description: "Erro no módulo funcional D",
			alarm: 51,
			type: "error",
			parameter: 204,
		},
		{
			bit: 4,
			description: "Erro no módulo funcional E",
			alarm: 52,
			type: "error",
			parameter: 204,
		},
		{
			bit: 5,
			description: "Erro no módulo opcional G",
			alarm: 53,
			type: "error",
			parameter: 204,
		},
		{
			bit: 6,
			description: "Erro no módulo opcional H",
			alarm: 54,
			type: "error",
			parameter: 204,
		},
		{
			bit: 7,
			description: "Erro no módulo opcional J",
			alarm: 55,
			type: "error",
			parameter: 204,
		},
		{
			bit: 8,
			description: "Erro no módulo opcional K",
			alarm: 56,
			type: "error",
			parameter: 204,
		},
		{
			bit: 9,
			description: "Erro no módulo opcional L",
			alarm: 57,
			type: "error",
			parameter: 204,
		},
		{
			bit: 10,
			description: "Erro no módulo opcional M",
			alarm: 58,
			type: "error",
			parameter: 204,
		},
		{
			bit: 11,
			description: "Timeout ao esperar pelo sinal RST dos escravos",
			alarm: 59,
			type: "error",
			parameter: 204,
		},
		{
			bit: 12,
			description: "Erro CRC no módulo de transmissão SPI e controlador",
			alarm: 60,
			type: "error",
			parameter: 204,
		},
		{
			bit: 13,
			description: "Erro CRC no controlador de transmissão SPI para o módulo",
			alarm: 61,
			type: "error",
			parameter: 204,
		},
	],
	// Parâmetro 205
	"Drivemanager.BM_w_PSU_SysError": [
		{
			bit: 0,
			description: "Falha de rede",
			alarm: 64,
			type: "error",
			parameter: 205,
		},
		{
			bit: 1,
			description: "Falha de fase",
			alarm: 65,
			type: "error",
			parameter: 205,
		},
		{
			bit: 4,
			description: "Subvoltagem 24V",
			alarm: 68,
			type: "error",
			parameter: 205,
		},
		{
			bit: 15,
			description: "Erro no monitor de grupo de alimentação",
			alarm: 79,
			type: "error",
			parameter: 205,
		},
	],
	// Parâmetro 206
	"Drivemanager.BM_w_AmpSysError": [
		{
			bit: 0,
			description: "Erro de comunicação após especificação Hiperface®",
			alarm: 80,
			type: "error",
			parameter: 206,
		},
		{
			bit: 1,
			description: "Temperatura do dissipador de calor",
			alarm: 81,
			type: "error",
			parameter: 206,
		},
		{
			bit: 2,
			description: "Sobretensão CL",
			alarm: 82,
			type: "error",
			parameter: 206,
		},
		{
			bit: 3,
			description: "Sobrecorrente",
			alarm: 83,
			type: "error",
			parameter: 206,
		},
		{
			bit: 4,
			description: "Corrente de terra",
			alarm: 84,
			type: "error",
			parameter: 206,
		},
		{
			bit: 5,
			description: "Temperatura interna do dispositivo",
			alarm: 85,
			type: "error",
			parameter: 206,
		},
		{
			bit: 6,
			description: "Ruptura de cabo do sensor de temperatura",
			alarm: 86,
			type: "error",
			parameter: 206,
		},
		{
			bit: 7,
			description: "Relé de segurança desligado (ou falho)",
			alarm: 87,
			type: "error",
			parameter: 206,
		},
		{
			bit: 8,
			description: "Curto-circuito de ponte",
			alarm: 88,
			type: "error",
			parameter: 206,
		},
		{
			bit: 9,
			description: "Unidade de força não pronta para operar",
			alarm: 89,
			type: "error",
			parameter: 206,
		},
		{
			bit: 10,
			description: "Falha de fase",
			alarm: 90,
			type: "error",
			parameter: 206,
		},
		{
			bit: 11,
			description: "Falha de rede",
			alarm: 91,
			type: "error",
			parameter: 206,
		},
		{
			bit: 12,
			description: "Subvoltagem de rede",
			alarm: 92,
			type: "error",
			parameter: 206,
		},
		{
			bit: 13,
			description: "Sobvoltagem de rede",
			alarm: 93,
			type: "error",
			parameter: 206,
		},
		{
			bit: 14,
			description: "Subvoltagem de circuito intermediário",
			alarm: 94,
			type: "error",
			parameter: 206,
		},
		{
			bit: 15,
			description: "Não atribuído",
			alarm: 95,
			type: "error",
			parameter: 206,
		},
	],
	// Parâmetro 207
	"Drivemanager.BM_w_MotorSysError": [
		{
			bit: 0,
			description: "Curto-circuito no sensor de temperatura (Tm <= -30°C)",
			alarm: 96,
			type: "error",
			parameter: 207,
		},
		{
			bit: 1,
			description: "Sensor de temperatura - motor não conectado (Tm > +300°C)",
			alarm: 97,
			type: "error",
			parameter: 207,
		},
		{
			bit: 2,
			description: "Sobreaquecimento do motor",
			alarm: 98,
			type: "error",
			parameter: 207,
		},
		{
			bit: 3,
			description: "Erro It > 100%",
			alarm: 99,
			type: "error",
			parameter: 207,
		},
		{
			bit: 4,
			description: "Erro de corrente máxima do drive (P1241)",
			alarm: 100,
			type: "error",
			parameter: 207,
		},
		{
			bit: 5,
			description: "Não atribuído",
			alarm: 101,
			type: "error",
			parameter: 207,
		},
		{
			bit: 6,
			description: "Erro de grupo na busca de posição de entalhe",
			alarm: 102,
			type: "error",
			parameter: 207,
		},
	],
	// Parâmetro 208
	"Drivemanager.BM_w_Enc1SysError": [
		{
			bit: 0,
			description: "Erro de comunicação Encoder 1 (Especificação-Hiperface®)",
			alarm: 112,
			type: "error",
			parameter: 208,
		},
		{
			bit: 1,
			description: "Erro na sobregravação da informação de posição de encoder",
			alarm: 114,
			type: "error",
			parameter: 208,
		},
		{
			bit: 3,
			description: "Ruptura de cabo Encoder 1",
			alarm: 115,
			type: "error",
			parameter: 208,
		},
		{
			bit: 4,
			description: "Sobrespeed do Encoder 1",
			alarm: 116,
			type: "error",
			parameter: 208,
		},
		{
			bit: 5,
			description: "Limite de amplitude excedido",
			alarm: 117,
			type: "error",
			parameter: 208,
		},
		{
			bit: 6,
			description: "Tipo de encoder desconhecido",
			alarm: 118,
			type: "error",
			parameter: 208,
		},
		{
			bit: 7,
			description: "Campo de dados inválido para dados de motor",
			alarm: 119,
			type: "error",
			parameter: 208,
		},
		{
			bit: 8,
			description: "Dados de motor incorretos",
			alarm: 120,
			type: "error",
			parameter: 208,
		},
		{
			bit: 9,
			description: "Erro ao salvar dados do motor",
			alarm: 121,
			type: "error",
			parameter: 208,
		},
		{
			bit: 10,
			description:
				"Dados de motor protegidos contra gravação (não válido para motores BM)",
			alarm: 122,
			type: "error",
			parameter: 208,
		},
		{
			bit: 11,
			description: "Erro de ângulo de campo",
			alarm: 123,
			type: "error",
			parameter: 208,
		},
		{
			bit: 12,
			description: "Encoder sem medição de temperatura",
			alarm: 124,
			type: "error",
			parameter: 208,
		},
		{
			bit: 13,
			description:
				"Capacidade de memória no encoder para placa tipo eletrônica pequena demais",
			alarm: 125,
			type: "error",
			parameter: 208,
		},
	],
	// Parâmetro 209
	"Drivemanager.BM_w_Enc2SysError": [
		{
			bit: 0,
			description: "Erro de comunicação Encoder 2 (Especificação-Hiperface®)",
			alarm: 128,
			type: "error",
			parameter: 209,
		},
		{
			bit: 1,
			description: "Código de módulo inválido",
			alarm: 129,
			type: "error",
			parameter: 209,
		},
		{
			bit: 2,
			description: "Erro na sobregravação de informação de posição do encoder",
			alarm: 130,
			type: "error",
			parameter: 209,
		},
		{
			bit: 3,
			description: "Ruptura de cabo Encoder 2",
			alarm: 131,
			type: "error",
			parameter: 209,
		},
		{
			bit: 4,
			description: "Sobrespeed do Encoder 2",
			alarm: 132,
			type: "error",
			parameter: 209,
		},
		{
			bit: 5,
			description: "Limite de amplitude excedido",
			alarm: 133,
			type: "error",
			parameter: 209,
		},
		{
			bit: 6,
			description: "Tipo de encoder desconhecido",
			alarm: 134,
			type: "error",
			parameter: 209,
		},
		{
			bit: 7,
			description: "Campo de dados inválido para dados de motor",
			alarm: 135,
			type: "error",
			parameter: 209,
		},
		{
			bit: 8,
			description: "Dados de motor incorretos",
			alarm: 136,
			type: "error",
			parameter: 209,
		},
		{
			bit: 9,
			description: "Erro ao salvar dados do motor",
			alarm: 137,
			type: "error",
			parameter: 209,
		},
		{
			bit: 10,
			description:
				"Dados de motor protegidos contra gravação (não válido para motores BM)",
			alarm: 138,
			type: "error",
			parameter: 209,
		},
		{
			bit: 11,
			description: "Erro de ângulo de campo",
			alarm: 139,
			type: "error",
			parameter: 209,
		},
		{
			bit: 12,
			description: "Encoder sem medição de temperatura",
			alarm: 140,
			type: "error",
			parameter: 209,
		},
		{
			bit: 13,
			description:
				"Capacidade de memória no encoder para placa tipo eletrônica pequena demais",
			alarm: 141,
			type: "error",
			parameter: 209,
		},
	],
	// Parâmetro 210
	"Drivemanager.BM_w_EncManagSysError": [
		{
			bit: 0,
			description: "Posição absoluta do encoder 1 desconhecida",
			alarm: 144,
			type: "error",
			parameter: 210,
		},
		{
			bit: 1,
			description: "Posição absoluta do encoder 2 desconhecida",
			alarm: 145,
			type: "error",
			parameter: 210,
		},
		{
			bit: 2,
			description: "Módulo de encoder 1 faltando",
			alarm: 146,
			type: "error",
			parameter: 210,
		},
		{
			bit: 3,
			description: "Módulo de encoder 2 faltando",
			alarm: 147,
			type: "error",
			parameter: 210,
		},
		{
			bit: 4,
			description:
				"Módulo de encoder para armazenamento de valor medido está faltando",
			alarm: 148,
			type: "error",
			parameter: 210,
		},
		{
			bit: 5,
			description:
				"Nenhuma possibilidade de armazenamento de valor medido no resolver",
			alarm: 149,
			type: "error",
			parameter: 210,
		},
		{
			bit: 6,
			description:
				"Nenhuma possibilidade de triggering por falta de encoder incremental",
			alarm: 150,
			type: "error",
			parameter: 210,
		},
		{
			bit: 7,
			description: "Módulo I/O digital está faltando",
			alarm: 151,
			type: "error",
			parameter: 210,
		},
		{
			bit: 8,
			description:
				"O módulo de emulação de encoder incremental é necessário e está faltando",
			alarm: 152,
			type: "error",
			parameter: 210,
		},
		{
			bit: 9,
			description:
				"Módulo de encoder 1 é necessário para a emulação de encoder incremental e está faltando",
			alarm: 153,
			type: "error",
			parameter: 210,
		},
		{
			bit: 10,
			description:
				"Módulo de encoder 2 é necessário para a emulação de encoder incremental e está faltando",
			alarm: 154,
			type: "error",
			parameter: 210,
		},
		{
			bit: 11,
			description:
				"Erro de inicialização do módulo de emulação de encoder incremental",
			alarm: 155,
			type: "error",
			parameter: 210,
		},
		{
			bit: 12,
			description:
				"Módulo de emulação de encoder incremental (HW) sinaliza erro",
			alarm: 156,
			type: "error",
			parameter: 210,
		},
		{
			bit: 13,
			description: "Erro do módulo de emulação de encoder incremental",
			alarm: 157,
			type: "error",
			parameter: 210,
		},
		{
			bit: 14,
			description: "Módulo de emulação de encoder SSI está faltando",
			alarm: 158,
			type: "error",
			parameter: 210,
		},
		{
			bit: 15,
			description: "Erro na fonte de valor nominal do encoder 1 ou encoder 2",
			alarm: 159,
			type: "error",
			parameter: 210,
		},
	],
	// Parâmetro 211
	"Drivemanager.BM_w_DriveManagSysError": [
		{
			bit: 0,
			description: "Timeout Comunicação",
			alarm: 160,
			type: "error",
			parameter: 211,
		},
		{
			bit: 1,
			description: "Timeout BACI",
			alarm: 161,
			type: "error",
			parameter: 211,
		},
		{
			bit: 2,
			description: "Timeout Comunicação Cíclica",
			alarm: 162,
			type: "error",
			parameter: 211,
		},
		{
			bit: 3,
			description: "Timeout Dados Requeridos",
			alarm: 163,
			type: "error",
			parameter: 211,
		},
		{
			bit: 4,
			description: "Erro Field bus",
			alarm: 164,
			type: "error",
			parameter: 211,
		},
		{
			bit: 5,
			description: "Controlador não síncrono ao sinal externo",
			alarm: 165,
			type: "error",
			parameter: 211,
		},
		{
			bit: 6,
			description: "Erro no controle de freio",
			alarm: 166,
			type: "error",
			parameter: 211,
		},
		{
			bit: 7,
			description: "Nenhuma abertura do freio de retenção no start do drive",
			alarm: 167,
			type: "error",
			parameter: 211,
		},
		{
			bit: 8,
			description: "Nenhum fechamento do freio de retenção na parada do drive",
			alarm: 168,
			type: "error",
			parameter: 211,
		},
		{
			bit: 9,
			description: "Erro status freio de retenção (monitorização cíclica)",
			alarm: 169,
			type: "error",
			parameter: 211,
		},
		{
			bit: 10,
			description: "Erro pastilha do freio de retenção",
			alarm: 170,
			type: "error",
			parameter: 211,
		},
		{
			bit: 11,
			description: "Erro freio de retenção Inicialização",
			alarm: 171,
			type: "error",
			parameter: 211,
		},
		{
			bit: 12,
			description:
				"Erro freio de retenção: Torque de retenção não atingido (a partir do FW 03.09)",
			alarm: 172,
			type: "error",
			parameter: 211,
		},
	],
	// Parâmetro 212
	"Drivemanager.BM_w_DataRecSysError": [
		{
			bit: 0,
			description: "Erro ao copiar EEPROM",
			alarm: 176,
			type: "error",
			parameter: 212,
		},
		{
			bit: 1,
			description: "Timeout ao gravar EEPROM",
			alarm: 177,
			type: "error",
			parameter: 212,
		},
		{
			bit: 2,
			description: "Erro de total de verificação EEPROM",
			alarm: 178,
			type: "error",
			parameter: 212,
		},
		{
			bit: 3,
			description: "Nenhum registro de dados de boot",
			alarm: 179,
			type: "error",
			parameter: 212,
		},
		{
			bit: 4,
			description: "Software incompatível",
			alarm: 180,
			type: "error",
			parameter: 212,
		},
		{
			bit: 5,
			description: "Sem registro de dados",
			alarm: 181,
			type: "error",
			parameter: 212,
		},
		{
			bit: 6,
			description: "Erro de total de verificação no módulo PSI",
			alarm: 182,
			type: "error",
			parameter: 212,
		},
		{
			bit: 7,
			description: "PSI é resetado",
			alarm: 183,
			type: "error",
			parameter: 212,
		},
		{
			bit: 8,
			description: "Dados PSI inválidos",
			alarm: 184,
			type: "error",
			parameter: 212,
		},
		{
			bit: 9,
			description: "Tabelas de auto-otimização inválidas",
			alarm: 185,
			type: "error",
			parameter: 212,
		},
		{
			bit: 10,
			description: "Tabelas corretivas A/D inválidas",
			alarm: 186,
			type: "error",
			parameter: 212,
		},
		{
			bit: 11,
			description: "EEPROM é resetado",
			alarm: 187,
			type: "error",
			parameter: 212,
		},
	],
	// Parâmetro 213
	"Drivemanager.BM_w_PosCtrlSysError": [
		{
			bit: 0,
			description: "Desvio de posição dinâmico",
			alarm: 192,
			type: "error",
			parameter: 213,
		},
		{
			bit: 1,
			description: "Desvio de posição estático",
			alarm: 193,
			type: "error",
			parameter: 213,
		},
		{
			bit: 2,
			description:
				"Encoder 1 é usado para controle de posição, mas está inativo",
			alarm: 194,
			type: "error",
			parameter: 213,
		},
		{
			bit: 3,
			description:
				"Encoder 2 é usado para controle de posição, mas está inativo",
			alarm: 195,
			type: "error",
			parameter: 213,
		},
		{
			bit: 4,
			description: "Chave limitadora - software 1 excedida",
			alarm: 196,
			type: "error",
			parameter: 213,
		},
		{
			bit: 5,
			description: "Chave limitadora - software 2 excedida",
			alarm: 197,
			type: "error",
			parameter: 213,
		},
		{
			bit: 6,
			description: "Chave limitadora - hardware 1 excedida",
			alarm: 198,
			type: "error",
			parameter: 213,
		},
		{
			bit: 7,
			description: "Chave limitadora - hardware 2 excedida",
			alarm: 199,
			type: "error",
			parameter: 213,
		},
		{
			bit: 8,
			description:
				"Posição inicial (homing) necessária, mas ainda não executada",
			alarm: 213,
			type: "error",
			parameter: 213,
		},
		{
			bit: 9,
			description:
				"Valor nominal no modo Set-of-setpoints não chegou em tempo hábil",
			alarm: 201,
			type: "error",
			parameter: 213,
		},
		{
			bit: 10,
			description: "Posição alvo >= Módulo posição",
			alarm: 202,
			type: "error",
			parameter: 213,
		},
		{
			bit: 11,
			description:
				"Posicionamento do spindle: Erro na inicialização do gatilho",
			alarm: 203,
			type: "error",
			parameter: 213,
		},
		{
			bit: 12,
			description: "Posicionamento do spindle: Timeout no gatilho",
			alarm: 204,
			type: "error",
			parameter: 213,
		},
		{
			bit: 13,
			description: "Erro no homing",
			alarm: 205,
			type: "error",
			parameter: 213,
		},
	],
	// Parâmetro 214
	"Drivemanager.BM_w_SpeedCtrlSysError": [
		{
			bit: 0,
			description: "Drive bloqueado",
			alarm: 208,
			type: "error",
			parameter: 214,
		},
		{
			bit: 1,
			description:
				"Encoder 1 está parametrizado como encoder para o controle do motor, mas a avaliação não está ativada",
			alarm: 209,
			type: "error",
			parameter: 214,
		},
		{
			bit: 2,
			description:
				"Encoder 2 está parametrizado como encoder para o controle do motor, mas a avaliação não está ativada",
			alarm: 210,
			type: "error",
			parameter: 214,
		},
		{
			bit: 3,
			description: "Sobrespeed em loop aberto",
			alarm: 211,
			type: "error",
			parameter: 214,
		},
		{
			bit: 4,
			description: "Limite para o desvio de velocidade foi excedido",
			alarm: 212,
			type: "error",
			parameter: 214,
		},
		{
			bit: 5,
			description:
				"Restrição de exportação: Frequência elétrica máxima excedida",
			alarm: 213,
			type: "error",
			parameter: 214,
		},
	],
	// Parâmetro 215
	"Drivemanager.BM_w_FreeCtrlSecSysError": [
		{
			bit: 11,
			description: "Acoplamento de torque: Erro geral no master",
			alarm: 0,
			type: "error",
			parameter: 215,
		},
		{
			bit: 12,
			description:
				"Acoplamento de torque: O modo de operação no slave não é controle de velocidade",
			alarm: 0,
			type: "error",
			parameter: 215,
		},
		{
			bit: 13,
			description:
				"Erro de configuração: A reação ao retorno de movimento é inválida",
			alarm: 0,
			type: "error",
			parameter: 215,
		},
		{
			bit: 14,
			description: "Destino do retorno de movimento não foi alcançado",
			alarm: 0,
			type: "error",
			parameter: 215,
		},
		{
			bit: 15,
			description: "Erro de aplicação (ativado pelo P03024 bit 1)",
			alarm: 0,
			type: "error",
			parameter: 215,
		},
	],
	// Parâmetro 216
	"Drivemanager.BM_w_CANSyncError": [
		{
			bit: 0,
			description: "Erro na cansync",
			alarm: 240,
			type: "error",
			parameter: 216,
		},
	],
	// Parâmetro 233
	"Drivemanager.BM_w_AmpHIPERFACEError": [
		{
			bit: 6,
			description: "Estouro de dados",
			alarm: 6,
			type: "error",
			parameter: 233,
		},
		{
			bit: 7,
			description: "Erro - Quadro de bits",
			alarm: 7,
			type: "error",
			parameter: 233,
		},
		{
			bit: 8,
			description: "Estado de comando inválido",
			alarm: 8,
			type: "error",
			parameter: 233,
		},
		{
			bit: 9,
			description: "Erro - Paridade",
			alarm: 9,
			type: "error",
			parameter: 233,
		},
		{
			bit: 10,
			description: "Erro - Total de verificação",
			alarm: 10,
			type: "error",
			parameter: 233,
		},
		{
			bit: 11,
			description: "Código de erro desconhecido",
			alarm: 11,
			type: "error",
			parameter: 233,
		},
		{
			bit: 12,
			description: "Erro de número de dados",
			alarm: 12,
			type: "error",
			parameter: 233,
		},
		{
			bit: 13,
			description: "Argumento inválido",
			alarm: 13,
			type: "error",
			parameter: 233,
		},
		{
			bit: 14,
			description: "Campo de dados é protegido contra gravação",
			alarm: 14,
			type: "error",
			parameter: 233,
		},
		{
			bit: 15,
			description: "Código de acesso inválido",
			alarm: 15,
			type: "error",
			parameter: 233,
		},
		{
			bit: 16,
			description: "Campo de dados não pode ser alterado em seu tamanho",
			alarm: 16,
			type: "error",
			parameter: 233,
		},
		{
			bit: 17,
			description: "Endereço de palavra fora do campo de dados",
			alarm: 17,
			type: "error",
			parameter: 233,
		},
		{
			bit: 18,
			description: "Campo de dados não existe",
			alarm: 18,
			type: "error",
			parameter: 233,
		},
		{
			bit: 36,
			description: "Total de verificação - Dados errados",
			alarm: 36,
			type: "error",
			parameter: 233,
		},
		{
			bit: 37,
			description: "Nenhuma resposta",
			alarm: 37,
			type: "error",
			parameter: 233,
		},
		{
			bit: 66,
			description: "Resposta inválida",
			alarm: 66,
			type: "error",
			parameter: 233,
		},
	],
	// Parâmetros 234
	"Drivemanager.BM_w_Enc1SerComError": [
		{
			bit: 1,
			description: "Sinais analógicos fora de especificação",
			alarm: 1,
			type: "error",
			parameter: 234,
		},
		{
			bit: 2,
			description: "Erro no offset de ângulo interno",
			alarm: 2,
			type: "error",
			parameter: 234,
		},
		{
			bit: 3,
			description: "Tabela de particionamento de campo de dados destruída",
			alarm: 3,
			type: "error",
			parameter: 234,
		},
		{
			bit: 4,
			description: "Valores limite analógicos não disponíveis",
			alarm: 4,
			type: "error",
			parameter: 234,
		},
		{
			bit: 5,
			description: "I²C-bus interno não operante",
			alarm: 5,
			type: "error",
			parameter: 234,
		},
		{
			bit: 6,
			description: "Erro de total de verificação interno",
			alarm: 6,
			type: "error",
			parameter: 234,
		},
		{
			bit: 7,
			description: "Erro watchdog interno - encoder reset",
			alarm: 7,
			type: "error",
			parameter: 234,
		},
		{
			bit: 8,
			description: "Estouro do contador",
			alarm: 8,
			type: "error",
			parameter: 234,
		},
		{
			bit: 9,
			description: "Erro paridade",
			alarm: 9,
			type: "error",
			parameter: 234,
		},
		{
			bit: 10,
			description: "Erro de total de verificação",
			alarm: 10,
			type: "error",
			parameter: 234,
		},
		{
			bit: 11,
			description: "Código de erro desconhecido",
			alarm: 11,
			type: "error",
			parameter: 234,
		},
		{
			bit: 12,
			description: "Erro de número de dados",
			alarm: 12,
			type: "error",
			parameter: 234,
		},
		{
			bit: 13,
			description: "Argumento inválido",
			alarm: 13,
			type: "error",
			parameter: 234,
		},
		{
			bit: 14,
			description: "Campo de dados é protegido contra gravação",
			alarm: 14,
			type: "error",
			parameter: 234,
		},
		{
			bit: 15,
			description: "Código de acesso inválido",
			alarm: 15,
			type: "error",
			parameter: 234,
		},
		{
			bit: 16,
			description: "Campo de dados não é alterável em seu tamanho",
			alarm: 16,
			type: "error",
			parameter: 234,
		},
		{
			bit: 17,
			description: "Endereço de palavra fora do campo de dados",
			alarm: 17,
			type: "error",
			parameter: 234,
		},
		{
			bit: 18,
			description: "Campo de dados não existe",
			alarm: 18,
			type: "error",
			parameter: 234,
		},
		{
			bit: 28,
			description: "Monitoramento absoluto dos sinais analógicos",
			alarm: 28,
			type: "error",
			parameter: 234,
		},
		{
			bit: 29,
			description: "Corrente de transmissão crítica",
			alarm: 29,
			type: "error",
			parameter: 234,
		},
		{
			bit: 30,
			description: "Temperatura de encoder crítica",
			alarm: 30,
			type: "error",
			parameter: 234,
		},
		{
			bit: 31,
			description: "Velocidade alta demais - geração de posição não é possível",
			alarm: 31,
			type: "error",
			parameter: 234,
		},
		{
			bit: 32,
			description: "Posição singleton incerta",
			alarm: 32,
			type: "error",
			parameter: 234,
		},
		{
			bit: 33,
			description: "Erro posição multiturn",
			alarm: 33,
			type: "error",
			parameter: 234,
		},
		{
			bit: 34,
			description: "Erro posição multiturn",
			alarm: 34,
			type: "error",
			parameter: 234,
		},
		{
			bit: 36,
			description: "Total de verificação de dados da unidade de força inválido",
			alarm: 36,
			type: "error",
			parameter: 234,
		},
		{
			bit: 37,
			description: "Nenhuma resposta do encoder",
			alarm: 37,
			type: "error",
			parameter: 234,
		},
		{
			bit: 66,
			description: "Resposta inútil para comando de encoder",
			alarm: 66,
			type: "error",
			parameter: 234,
		},
		{
			bit: 80,
			description: "CRC determinou um erro",
			alarm: 80,
			type: "error",
			parameter: 234,
		},
		{
			bit: 81,
			description: "Comando inválido",
			alarm: 81,
			type: "error",
			parameter: 234,
		},
		{
			bit: 82,
			description: "Erro no telegrama de resposta",
			alarm: 82,
			type: "error",
			parameter: 234,
		},
		{
			bit: 83,
			description: "Bit de alarme está ajustado",
			alarm: 83,
			type: "error",
			parameter: 234,
		},
		{
			bit: 84,
			description: "Memória está ocupada",
			alarm: 84,
			type: "error",
			parameter: 234,
		},
		{
			bit: 98,
			description: "Erro valor de posição",
			alarm: 98,
			type: "error",
			parameter: 234,
		},
		{
			bit: 99,
			description: "Erro sobretensão",
			alarm: 99,
			type: "error",
			parameter: 234,
		},
		{
			bit: 100,
			description: "Erro subtensão",
			alarm: 100,
			type: "error",
			parameter: 234,
		},
		{
			bit: 101,
			description: "Erro sobrecorrente",
			alarm: 101,
			type: "error",
			parameter: 234,
		},
		{
			bit: 102,
			description: "Erro bateria",
			alarm: 102,
			type: "error",
			parameter: 234,
		},
	],
	// PARÂMETRO 235
	"Drivemanager.BM_w_Enc2SerComError": [
		{
			bit: 1,
			description: "Sinais analógicos fora de especificação",
			alarm: 1,
			type: "error",
			parameter: 235,
		},
		{
			bit: 2,
			description: "Erro no offset de ângulo interno",
			alarm: 2,
			type: "error",
			parameter: 235,
		},
		{
			bit: 3,
			description: "Tabela de particionamento de campo de dados destruída",
			alarm: 3,
			type: "error",
			parameter: 235,
		},
		{
			bit: 4,
			description: "Valores limite analógicos não disponíveis",
			alarm: 4,
			type: "error",
			parameter: 235,
		},
		{
			bit: 5,
			description: "I²C-bus interno não operante",
			alarm: 5,
			type: "error",
			parameter: 235,
		},
		{
			bit: 6,
			description: "Erro de total de verificação interno",
			alarm: 6,
			type: "error",
			parameter: 235,
		},
		{
			bit: 7,
			description: "Erro watchdog interno - encoder reset",
			alarm: 7,
			type: "error",
			parameter: 235,
		},
		{
			bit: 8,
			description: "Estouro do contador",
			alarm: 8,
			type: "error",
			parameter: 235,
		},
		{
			bit: 9,
			description: "Erro paridade",
			alarm: 9,
			type: "error",
			parameter: 235,
		},
		{
			bit: 10,
			description: "Erro de total de verificação",
			alarm: 10,
			type: "error",
			parameter: 235,
		},
		{
			bit: 11,
			description: "Código de erro desconhecido",
			alarm: 11,
			type: "error",
			parameter: 235,
		},
		{
			bit: 12,
			description: "Erro de número de dados",
			alarm: 12,
			type: "error",
			parameter: 235,
		},
		{
			bit: 13,
			description: "Argumento inválido",
			alarm: 13,
			type: "error",
			parameter: 235,
		},
		{
			bit: 14,
			description: "Campo de dados é protegido contra gravação",
			alarm: 14,
			type: "error",
			parameter: 235,
		},
		{
			bit: 15,
			description: "Código de acesso inválido",
			alarm: 15,
			type: "error",
			parameter: 235,
		},
		{
			bit: 16,
			description: "Campo de dados não é alterável em seu tamanho",
			alarm: 16,
			type: "error",
			parameter: 235,
		},
		{
			bit: 17,
			description: "Endereço de palavra fora do campo de dados",
			alarm: 17,
			type: "error",
			parameter: 235,
		},
		{
			bit: 18,
			description: "Campo de dados não existe",
			alarm: 18,
			type: "error",
			parameter: 235,
		},
		{
			bit: 28,
			description: "Monitoramento absoluto dos sinais analógicos",
			alarm: 28,
			type: "error",
			parameter: 235,
		},
		{
			bit: 29,
			description: "Corrente de transmissão crítica",
			alarm: 29,
			type: "error",
			parameter: 235,
		},
		{
			bit: 30,
			description: "Temperatura de encoder crítica",
			alarm: 30,
			type: "error",
			parameter: 235,
		},
		{
			bit: 31,
			description: "Velocidade alta demais - geração de posição não é possível",
			alarm: 31,
			type: "error",
			parameter: 235,
		},
		{
			bit: 32,
			description: "Posição singleton incerta",
			alarm: 32,
			type: "error",
			parameter: 235,
		},
		{
			bit: 33,
			description: "Erro posição multiturn",
			alarm: 33,
			type: "error",
			parameter: 235,
		},
		{
			bit: 34,
			description: "Erro posição multiturn",
			alarm: 34,
			type: "error",
			parameter: 235,
		},
		{
			bit: 36,
			description: "Total de verificação de dados da unidade de força inválido",
			alarm: 36,
			type: "error",
			parameter: 235,
		},
		{
			bit: 37,
			description: "Nenhuma resposta do encoder",
			alarm: 37,
			type: "error",
			parameter: 235,
		},
		{
			bit: 66,
			description: "Resposta inútil para comando de encoder",
			alarm: 66,
			type: "error",
			parameter: 235,
		},
		{
			bit: 80,
			description: "CRC determinou um erro",
			alarm: 80,
			type: "error",
			parameter: 235,
		},
		{
			bit: 81,
			description: "Comando inválido",
			alarm: 81,
			type: "error",
			parameter: 235,
		},
		{
			bit: 82,
			description: "Erro no telegrama de resposta",
			alarm: 82,
			type: "error",
			parameter: 235,
		},
		{
			bit: 83,
			description: "Bit de alarme está ajustado",
			alarm: 83,
			type: "error",
			parameter: 235,
		},
		{
			bit: 84,
			description: "Memória está ocupada",
			alarm: 84,
			type: "error",
			parameter: 235,
		},
		{
			bit: 98,
			description: "Erro valor de posição",
			alarm: 98,
			type: "error",
			parameter: 235,
		},
		{
			bit: 99,
			description: "Erro sobretensão",
			alarm: 99,
			type: "error",
			parameter: 235,
		},
		{
			bit: 100,
			description: "Erro subtensão",
			alarm: 100,
			type: "error",
			parameter: 235,
		},
		{
			bit: 101,
			description: "Erro sobrecorrente",
			alarm: 101,
			type: "error",
			parameter: 235,
		},
		{
			bit: 102,
			description: "Erro bateria",
			alarm: 102,
			type: "error",
			parameter: 235,
		},
	],
	// Parâmetro 236
	"Drivemanager.BM_w_MainsMonitorError": [
		{
			bit: 0,
			description: "Monitor de rede detectou erro - Falha de rede",
			alarm: 0,
			type: "error",
			parameter: 236,
		},
		{
			bit: 1,
			description: "Monitor de rede detectou erro - Falha de fase",
			alarm: 0,
			type: "error",
			parameter: 236,
		},
		{
			bit: 2,
			description: "Monitor de rede detectou erro - Subtensão da rede",
			alarm: 0,
			type: "error",
			parameter: 236,
		},
		{
			bit: 3,
			description: "Monitor de rede detectou erro - Sobretensão da rede",
			alarm: 0,
			type: "error",
			parameter: 236,
		},
		{
			bit: 4,
			description:
				"Monitor de rede detectou erro - Frequência da rede abaixo do limite inferior",
			alarm: 0,
			type: "error",
			parameter: 236,
		},
		{
			bit: 5,
			description:
				"Monitor de rede detectou erro - Frequência da rede acima do limite superior",
			alarm: 0,
			type: "error",
			parameter: 236,
		},
	],
	// Parâmetro 237
	"Drivemanager.BM_w_RastRefError": [
		{
			bit: 0,
			description: "Sobrecorrente no passo 1",
			alarm: 0,
			type: "error",
			parameter: 237,
		},
		{
			bit: 1,
			description: "Sobrecorrente no passo 2",
			alarm: 0,
			type: "error",
			parameter: 237,
		},
		{
			bit: 2,
			description: "Erro de plausibilidade no passo 1",
			alarm: 0,
			type: "error",
			parameter: 237,
		},
		{
			bit: 3,
			description: "Erro de plausibilidade no passo 2",
			alarm: 0,
			type: "error",
			parameter: 237,
		},
		{ bit: 5, description: "Timeout", alarm: 0, type: "error", parameter: 237 },
		{
			bit: 6,
			description:
				"O drive se moveu mais do que 4 vezes o ângulo de trajetória",
			alarm: 0,
			type: "error",
			parameter: 237,
		},
		{
			bit: 9,
			description:
				"Erro de plausibilidade no passo 2 - inválido (a partir do FW 03.10)",
			alarm: 0,
			type: "error",
			parameter: 237,
		},
	],
	// Parâmetro 240
	"Drivemanager.BM_w_SmallModuleErrorA": [],
	// PARÂMETRO 241
	"Drivemanager.BM_w_SmallModuleErrorB": [],
	// PARÂMETRO 242
	"Drivemanager.BM_w_SmallModuleErrorC": [],
	// PARÂMETRO 243
	"Drivemanager.BM_w_SmallModuleErrorD": [],
	// PARÂMETRO 244
	"Drivemanager.BM_w_SmallModuleErrorE": [],
	// PARÂMETRO 245
	"Drivemanager.BM_w_BigModuleErrorG": [],
	// PARÂMETRO 246
	"Drivemanager.BM_w_BigModuleErrorH": [],
	// PARÂMETRO 247
	"Drivemanager.BM_w_BigModuleErrorJ": [],
	// PARÂMETRO 248
	"Drivemanager.BM_w_BigModuleErrorK": [],
	// PARÂMETRO 249
	"Drivemanager.BM_w_BigModuleErrorL": [],
	// PARÂMETRO 250
	"Drivemanager.BM_w_BigModuleErrorM": [],
	// PARÂMETRO 251
	"Drivemanager.BM_u_ProprogCmdErrId": [],
	// PARÂMETRO 260
	"Drivemanager.BM_w_SysWarning1": [],
	// PARÂMETRO 261
	"Drivemanager.BM_w_PSU_Warning": [],
	// PARÂMETRO 262
	"Drivemanager.BM_w_AmpWarning": [],
	// PARÂMETRO 263
	"Drivemanager.BM_w_MotorWarning": [],
	// PARÂMETRO 264
	"Drivemanager.BM_w_DriveWarning": [],
	// PARÂMETRO 265
	"Drivemanager.BM_w_MainsMonitorWarning": [],
	// PARÂMETRO 300
	"Drivemanager.BM_w_Controlword": [],
	// PARÂMETRO 301
	"Drivemanager.BM_w_Statusword": [],
	// PARÂMETRO 303
	"Drivemanager.BM_w_Statusword2": [],
	// PARÂMETRO 304
	"Drivemanager.BM_i_OperationModeAct": [],
	// PARÂMETRO 305
	"Drivemanager.BM_w_DriveStatus": [],
	// PARÂMETRO 306
	"Drivemanager.BM_w_DI_StatusDrvControl": [],
	// PARÂMETRO 308
	"Drivemanager.BM_w_Statusword3": [],
	// PARÂMETRO 461
	"Drivemanager.BM_w_PPosSwitchStatus": [],
	// PARÂMETRO 1000
	"Drivemanager.BM_i_Ds0_OperationMode": [],
};

interface ErrorResult {
	key: string;
	bit: number;
	description: string;
	alarm: string;
	type: string;
	parameter: string;
}

export function getErrorMessages(errorData: {
	[key: string]: number;
}): ErrorResult[] {
	const result: ErrorResult[] = [];
	for (const key in errorData) {
		if (errorData.hasOwnProperty(key) && errorDefinitions.hasOwnProperty(key)) {
			const value = errorData[key];
			const binaryString = value
				.toString(2)
				.padStart(16, "0")
				.split("")
				.reverse()
				.join("");
			const errors = errorDefinitions[key];
			for (let i = 0; i < binaryString.length; i++) {
				if (binaryString[i] === "1") {
					const error = errors.find((error) => error.bit === i);
					if (error) {
						result.push({
							key,
							bit: i,
							description: error.description,
							alarm: `${error.alarm}`,
							type: error.type,
							parameter: `${error.parameter}`,
						});
					}
				}
			}
		}
	}
	return result.filter((item) => item.alarm !== "0");
}

export const downloadXlsx = (dataList: any[], fileName: string) => {
	const dataKeysSet = new Set<string>();
	dataList.forEach((item) => {
		if (item.data) {
			Object.keys(item.data).forEach((key) => dataKeysSet.add(key));
		}
	});
	const dataKeys = Array.from(dataKeysSet);

	const headers = ["deviceId", "updatedAt", "createdAt", "id", ...dataKeys];

	const rows = dataList.map((item) => {
		const row: any = {
			deviceId: item.deviceId,
			updatedAt: item.updatedAt,
			createdAt: item.createdAt,
			id: item.id,
		};
		dataKeys.forEach((key) => {
			row[key] = item.data ? item.data[key] : "";
		});
		return row;
	});

	const worksheet = XLSX.utils.json_to_sheet(rows, { header: headers });
	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, worksheet, "Devices Data");

	XLSX.writeFile(workbook, fileName);
};
